import { render } from "./LiveDock.vue?vue&type=template&id=c4d131a2&scoped=true"
import script from "./LiveDock.vue?vue&type=script&lang=js"
export * from "./LiveDock.vue?vue&type=script&lang=js"

import "./LiveDock.vue?vue&type=style&index=0&id=c4d131a2&lang=scss&scoped=true"

import exportComponent from "/home/vueltaciclista/app/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4d131a2"]])

export default __exports__